import MobileDetect from 'mobile-detect';
window.isTablet = new MobileDetect(window.navigator.userAgent).tablet();
